var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "80px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          searchBtnHide: !!_vm.$store.getters.cusId,
          resetBtnHide: !!_vm.$store.getters.cusId,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u(
          [
            !_vm.$store.getters.cusId
              ? {
                  key: "baseForm",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.CustomerName"),
                                prop: "clientCode",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  clearable: false,
                                  "option-list": _vm.clientCodeList,
                                  placeholder: _vm.$t(
                                    "billingPage.CustomerName"
                                  ),
                                },
                                model: {
                                  value: _vm.queryParams.clientCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParams, "clientCode", $$v)
                                  },
                                  expression: "queryParams.clientCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("table.createTimeText"),
                                prop: "creationDate",
                              },
                            },
                            [
                              _c("BjDateRangePicker", {
                                attrs: {
                                  placeholder: _vm.$t("table.createTimeText"),
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.dataTime,
                                  callback: function ($$v) {
                                    _vm.dataTime = $$v
                                  },
                                  expression: "dataTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "tableOperation",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "main-btn",
                          attrs: { type: "primary" },
                          on: { click: _vm.onAdd },
                        },
                        [_vm._v(_vm._s(_vm.$t("addText")))]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      col.prop === "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDetail(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("editText")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }